var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Production-Plan-Item"},[_c('PageTitle',{attrs:{"imagem":"pop2.png","main":"Cadastro de Itens do Plano de Safra","sub":""}}),_c('ProductionPlanEditor')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }